import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import intro from './assets/introC.jpg'
import Bascis from './assets/Basics.png'
import vck from './assets/vck.png'
import eveadd from './assets/eveodd.jpg'
import ap from './assets/ap.png'
import primec from './assets/primec++.jpg'
import ncr from './assets/ncr.jfif'
import pattern from './assets/pattern.png'
import da from './assets/da.jpg'
import strMax from './assets/strMax.png'
import strDup from './assets/strDup.png'
import tog from './assets/tog.png'
import rec from './assets/rec.jpeg'
import perm from './assets/perm.png'
import DMA from './assets/DMA.png'
import pi from './assets/pi.jpg'
import del from './assets/del.webp'
import delw from './assets/delw.png'
import merge from './assets/merge.png'
import stkRev from './assets/stkRev.png'
import inPo from './assets/InPo.png'
import stkspan from './assets/stkspan.png'
import tcp from './assets/tcp.jpg'
import toh from './assets/toh.png'
import stksrt from './assets/stksrt.png'
import vec from './assets/vec.jpg'
import map from './assets/map.png'
import BCC from './assets/BCC.jpg'
import Flow from './assets/flowchart.jpg'
import FlowQ from './assets/flowQ.png'
import temp from './assets/template.png'
import loop from './assets/loop.jpeg'
import Db from './assets/DB.png'
import Dat from './assets/Data.png'
import Arr from './assets/Array.png'
import RevArr from './assets/RevArr.gif'
import ls from './assets/ls.jpg'
import bble from './assets/bble.png'
import ss from './assets/ss.png'
import ptr from './assets/ptr.jfif'
import str from './assets/str.jfif'
import Rtt from './assets/Rtt.png'
import strRev from './assets/strRev.jpg'
import Plndrm from './assets/plndrm.png'
import Oop from './assets/oop.jpeg'
import rmz from './assets/rmz.jfif'
import Nque from './assets/nque.png'
import Com from './assets/com.jpg'
import ll from './assets/ll.jfif'
import inter from './assets/inter.jpg'
import stk from './assets/stk.png'
import q from './assets/q.jfif'
const Cpp = () => {
    return (
        <div >
           <h1 style={{textAlign:'center'}}>Topics to be Covered</h1>
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={intro}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>C++ Language Introduction</p>
      <NavLink to='/category/cpp/introduction'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={BCC} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Basics computer Operation</p>
      <NavLink to='/category/cpp/Basics of computer operation'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Flow} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Flowchart and Pseudocodes</p>
        <NavLink to='/category/cpp/Flow chart and Pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 1">
    <div class="card_image">
      <img src={FlowQ} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Print Hello world 10 Times by flowchart and Pseudocode</p>
      <NavLink to='/category/cpp/Print hello world 10 time by flow chart and pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={FlowQ}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Write a pseudocode and flowchart to check give number is prime or not?</p>
      <NavLink to='/category/cpp/Check Prime or not by flow  chart and pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={FlowQ} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Write a pseudocode and flowchart to find the sum of n number</p>
      <NavLink to='./category/cpp/Sum of N natural numbers by flow chart and pseudocode'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={Bascis} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Basics of Coding</p>
        <NavLink to='/category/cpp/Concepts of Coding'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={temp} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}> Template</p>
      <NavLink to='/category/cpp/Template'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={vck}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Variables Constant and Keywords</p>
      <NavLink to='/category/cpp/Keywords Variable and Constant'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={loop} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Loop</p>
      <NavLink to='/category/cpp/Loops'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={eveadd} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>C++ program to print all Even and Odd numbers from 1 to N</p>
        <NavLink to='/category/cpp/Cpp program to print all Even and Odd numbers from 1 to N'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={ap} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Print A.P. till N</p>
      <NavLink to='/category/cpp/Program to print Arithmetic Progression series'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={primec}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Write a program to check whether a number is prime or not?</p>
      <NavLink to='/category/cpp/Write a program to check whether a number is prime or not'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Db} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Write a program to convert a number from Decimal to Binary</p>
      <NavLink to='/category/cpp/Program for Decimal to Binary Conversion'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ncr} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Write nCr formulae program?</p>
        <NavLink to="/category/cpp/Program to calculate value of nCr">
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={pattern} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Pattern</p>
      <NavLink to='/category/cpp/Alphabet pattern'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Dat}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Data Types</p>
      <NavLink to='/category/cpp/Data types'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Arr} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Arrays</p>
      <NavLink to='/category/cpp/Array'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={RevArr} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Print n numbers of array in reverse order.</p>
        <NavLink to='/category/cpp/Write a program to reverse an array or string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={ls} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Write a program to do linear search</p>
      <NavLink to='/category/cpp/Write a program to do linear search'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={bble}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Write a program to do bubble sort.</p>
      <NavLink to='/category/cpp/Write a program to do Bubble sort'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={ss} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Write a program to Selection sort.</p>
      <NavLink to='/category/cpp/Write a program to do Selection sort'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={ptr} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Pointers</p>
        <NavLink to='/category/cpp/Pointers'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={da} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Default argument</p>
      <NavLink to='/category/cpp/Default Argument'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={str}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>String</p>
      <NavLink to='/category/cpp/String'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Rtt} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Rotate a matrix by 90 anticlockwise without using STL.</p>
      <NavLink to='/category/cpp/Rotate matrix by 90degree anticlockwise'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={strRev} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Reverse a string</p>
        <NavLink to='/category/cpp/Reverse the string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={strMax} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}> find the maximum occurring character in a given String</p>
      <NavLink to='/category/cpp/Different methods to reverse a string in C/C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
          <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={strDup}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>remove all duplicates from a given string?</p>
      <NavLink to='/category/cpp/Remove duplicates from a given string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={tog} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Toggle the given string</p>
      <NavLink to='/category/cpp/Program to toggle all characters in a string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={rec} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Recurssion</p>
        <NavLink to='/category/cpp/Recurssion in C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>  

  <div class="card 1">
    <div class="card_image">
      <img src={Plndrm} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Check if a number is Palindrome by recurssion</p>
        <NavLink to='/category/cpp/Recursive program to check if number is palindrome or not C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  </div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
    <div class="card 2">
    <div class="card_image">
      <img src={perm} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>print all permutation of a String?</p>
      <NavLink to='/category/cpp/Write a program to print all permutations of a given string'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
      

    <div class="card 1">
    <div class="card_image"> <img src={Oop}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Oops</p>
      <NavLink to='/category/cpp/Oops in C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
   
        
  
  <div class="card 1">
    <div class="card_image"> <img src={DMA}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>DMA- Dynamic Memory Allocation</p>
      <NavLink to='/category/cpp/Dynamic Memory Allocation'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={rmz} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Rat in a Maze</p>
      <NavLink to='/category/cpp/Rat in a Maze C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  </div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={Nque} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>N- queen Problem</p>
        <NavLink to='/category/cpp/C++ Program to Solve N-Queen Problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={Com} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Class and its member</p>
      <NavLink to='/category/cpp/Class and its member C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
      
  
  <div class="card 1">
    <div class="card_image"> <img src={pi}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Polymorphism and Inheritance</p>
      <NavLink to='/category/cpp/Difference between Inheritance and Polymorphism'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={ll} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Linked list</p>
      <NavLink to='/category/cpp/Linked list'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
 </div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={del} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Delete Values at given position</p>
        <NavLink to='/category/cpp/Delete a Linked List node at a given position'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={delw} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Delete Whole Linked list</p>
      <NavLink to='/category/cpp/Write a function to delete a Linked List'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
     
        
  <div class="card 1">
    <div class="card_image"> <img src={inter}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find the intersection of two linked list</p>
      <NavLink to='/category/cpp/Write a function to get the intersection point of two Linked Lists'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={merge} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Merge sort two linked list</p>
      <NavLink to='/category/cpp/Merge two sorted linked lists'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
 </div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={stk} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Stack</p>
        <NavLink to='/category/cpp/Stack in C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={stkRev} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Reverse the stack</p>
      <NavLink to='/category/cpp/Reverse Stack in C++'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
  
  <div class="card 1">
    <div class="card_image"> <img src={inPo}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Infix to Postfix Conversion using Stack</p>
      <NavLink to='/category/cpp/Infix to Postfix'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={stkspan} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>The Stock Span Problem</p>
      <NavLink to='/category/cpp/The stock span problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
</div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={tcp} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>The Celebrity Problem</p>
        <NavLink to='/category/cpp/The Celebrity Problem'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={toh} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Iterative Tower of Hanoi</p>
      <NavLink to='/category/cpp/Tower of hanoi'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    
  <div class="card 1">
    <div class="card_image"> <img src={stksrt}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Sort the stack</p>
      <NavLink to='/category/cpp/Sort the stack'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={q} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Queue</p>
      <NavLink to='/category/cpp/queue'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  </div>
  <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  <div class="card 1">
    <div class="card_image">
      <img src={vec} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Vector</p>
        <NavLink to='/category/cpp/vector'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={map} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Map</p>
      <NavLink to='/category/cpp/map'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>    
         
    </div>    
     
    )
}

export default Cpp
